import { SET_OPTIONS } from '../actions/types';

export default function options(state = [], action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_OPTIONS:
				return action.payload;

			// no default
		}
	}

	return state;
}
